// Calendar info texts (Kassa infotekstit), realtime db infotexts/<customer>/<id>:
//   { text, visible, start: 'YYYY-MM-DD', end: 'YYYY-MM-DD', categories?: [...], state? }
//
// `visible` has been stored in more than one shape over the years: 'admin' / 'cashier' from
// the current form, 'all' from older data, and occasionally a capitalised, plural or missing
// value. Read through infotextAudience so every view agrees on who sees a text.

const ALIASES = {
  admin: 'admin',
  admins: 'admin',
  cashier: 'cashier',
  cashiers: 'cashier',
  kassa: 'cashier',
  all: 'all',
  both: 'all',
  kaikki: 'all',
}

// 'admin' | 'cashier' | 'all'. Missing or unknown falls back to 'admin', the form's default,
// so a text never leaks to the cashier view by accident.
export const infotextAudience = (visible) => {
  if (Array.isArray(visible)) {
    const audiences = new Set(visible.map(infotextAudience))
    if (audiences.has('all') || (audiences.has('admin') && audiences.has('cashier'))) return 'all'
    return audiences.has('cashier') ? 'cashier' : 'admin'
  }
  if (typeof visible !== 'string') return 'admin'
  return ALIASES[visible.trim().toLowerCase()] || 'admin'
}

// ADMIN reads the admin texts; CASHIER, PARTNER and COOPERATIVE share the cashier layout and
// read the cashier texts. 'all' reaches both.
export const infotextVisibleTo = (infotext, role) => {
  const audience = infotextAudience(infotext && infotext.visible)
  if (audience === 'all') return true
  return audience === (role === 'ADMIN' ? 'admin' : 'cashier')
}

export const INFOTEXT_AUDIENCE_LABELS = { admin: 'Admin', cashier: 'Kassa', all: 'Kaikki' }
